import IconButton from "..";
import { CheckIcon } from "@/constant/imagePath";

const ReopenButton = ({
  icon = CheckIcon,
  borderColor = "#05A16D",
  fromColor = "#19C38B",
  toColor = "#088D96",
  buttonStyle = { padding: "3.3px 2.5px" },
  onClick = null,
  tooltipText,
  ...props
}) => {
  return (
    <IconButton
      icon={icon}
      borderColor={borderColor}
      fromColor={fromColor}
      toColor={toColor}
      buttonStyle={buttonStyle}
      onClick={onClick}
      tooltipText={tooltipText}
      {...props}
    />
  );
};

export default ReopenButton;
